import React, { useEffect, useRef, useState } from 'react';
import { CupertinoPane } from 'cupertino-pane';
import baseTheme from '../baseTheme';

const BottomSheet = ({ children }) => {
  const paneRef = useRef(null);

  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setMobile(window.innerWidth < 700);
    };
    setMobile(window.innerWidth < 700);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (mobile) {
      paneRef.pane = new CupertinoPane(paneRef.current, {
        breaks: {
          top: {
            enabled: true,
            height: window.innerHeight - 120,
            bounce: true,
          },
          middle: { enabled: true, height: window.innerHeight - 300 },
          bottom: { enabled: true, height: 150 },
        },
        buttonDestroy: false,

        fastSwipeClose: false,
        bottomClose: false,
        initialBreak: 'middle',
      });
      paneRef.pane.present({ animate: true });
    } else {
      paneRef.pane && paneRef.pane.destroy({ animate: false });
    }
  }, [mobile]);

  return (
    <div
      ref={paneRef}
      style={{
        background: baseTheme.neutrals['100'],
      }}
    >
      <div style={{ padding: mobile ? '1rem 1rem 2rem' : '0' }}>{children}</div>
    </div>
  );
};

export default BottomSheet;
